/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICipChannelNotificationViewProps } from './cip-channel-notification';
import { AUTO_LINK_CUSTOMER_NOT_FOUND, COMMERCE_CUSTOMER_IDENTITY_NOT_FOUND } from './constants';

const CipChannelNotificationView: React.FC<ICipChannelNotificationViewProps> = props => {
    const [hasError, setHasError] = React.useState(false);

    // Listen for custom event when channel notification error occurs
    React.useEffect(() => {
        const handleChannelError = () => {
            setHasError(true);
        };

        globalThis.addEventListener('cip:channelNotification:error', handleChannelError);

        return () => {
            globalThis.removeEventListener('cip:channelNotification:error', handleChannelError);
        };
    }, []);

    const user = props.context?.actionContext?.requestContext?.user;

    // Primary check: explicit retailServerErrorCode set by hooks or other code
    const errorCode = user?.retailServerErrorCode;

    // Secondary check: inspect any user-side error payload for the known exception identifier
    const userString = user ? JSON.stringify(user) : '';

    const isModalOpen = hasError || errorCode === AUTO_LINK_CUSTOMER_NOT_FOUND || userString.includes(COMMERCE_CUSTOMER_IDENTITY_NOT_FOUND);

    return (
        <>
            {isModalOpen && (
                <Modal autoFocus isOpen backdrop='static' keyboard={false}>
                    <ModalHeader tag='h3'>{props.resources.modalHeading}</ModalHeader>
                    <ModalBody>
                        <p className='cip-channel-notification__text'>{props.resources.modalMessage}</p>
                        <a className='cip-channel-notification__sign-out-link' href={props.config.signOutRoute}>
                            {props.resources.modalCloseButtonText}
                        </a>
                    </ModalBody>
                    <ModalFooter />
                </Modal>
            )}
        </>
    );
};

export default CipChannelNotificationView;
